import _ from 'lodash';
import React from 'react';
import { Image } from 'console-kit';

const FIELD_TEMPLATES = {
  GRID:       'template:common:form:field.radio.grid',
  HORIZONTAL: 'template:common:form:field.radio.horizontal',
  VERTICAL:   'template:common:form:field.radio.vertical',

  RT_HORIZONTAL: 'template:common:realtimepoll:horizontal',
  RT_VERTICAL:   'template:common:realtimepoll:vertical',
  RT_LIST:       'template:common:realtimepoll:list',
  RT_GRID:       'template:common:realtimepoll:grid',
};

FIELD_TEMPLATES.ALL = _.values(FIELD_TEMPLATES);

FIELD_TEMPLATES.CONFIGS = {
  [FIELD_TEMPLATES.VERTICAL]: {
    text:  'List',
    value: FIELD_TEMPLATES.VERTICAL,
    image: <Image src={App.globalContext.assetURL + 'c/img/screen-designer/radio/radio-template-vertical.svg'} />,
  },

  //[WYN-8386 - the stack option will be deprecated slowly for MX experiences]
  [FIELD_TEMPLATES.HORIZONTAL]: {
    text:  'Stack',
    value: FIELD_TEMPLATES.HORIZONTAL,
    image: <Image src={App.globalContext.assetURL + 'c/img/screen-designer/radio/radio-template-horizontal.svg'} />,
  },

  [FIELD_TEMPLATES.GRID]: {
    text:  'Grid',
    value: FIELD_TEMPLATES.GRID,
    image: <Image src={App.globalContext.assetURL + 'c/img/screen-designer/radio/radio-template-grid.svg'} />,
  },
};

FIELD_TEMPLATES.RADIO_LIST = [
  FIELD_TEMPLATES.CONFIGS[FIELD_TEMPLATES.VERTICAL],
  //soon to be deprecated
  FIELD_TEMPLATES.CONFIGS[FIELD_TEMPLATES.HORIZONTAL],
  FIELD_TEMPLATES.CONFIGS[FIELD_TEMPLATES.GRID],
];

FIELD_TEMPLATES.CHECKBOX_LIST = [
  FIELD_TEMPLATES.CONFIGS[FIELD_TEMPLATES.VERTICAL],
  FIELD_TEMPLATES.CONFIGS[FIELD_TEMPLATES.GRID],
];

export default FIELD_TEMPLATES;
